import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import {findFragmentParent, Fragment} from "dce-fragments";
import Dce from "dce-engine/lib/decorators/Dce";
import {FullCalendar, FullCalendarProps} from "dce-fullcalendar";
import {EventClickArg, EventInput} from "@fullcalendar/common";
import {DceWebSocketConnection, DceWebSocketIncomingMessage, DceWebSocketSubscribeHandle} from "dce-websocket";

interface FullCalendarForFragmentsProps extends FullCalendarProps{
    action: string,
    channel: string
}

interface WebSocketMsgResolved {
    id: string,
    resolved: boolean;
}

/**
 * Full calendar z fragmentami
 */
@Dce("FullCalendarForFragments")
export default class FullCalendarForFragments extends FullCalendar<FullCalendarForFragmentsProps> {

    private parentFragment: Fragment;
    private subHandle: DceWebSocketSubscribeHandle;

    constructor(elem: DceHTMLElement, props: FullCalendarForFragmentsProps) {
        super(elem, props);
        this.parentFragment = findFragmentParent(elem);

        if(this.props.channel) {
            this.subHandle = DceWebSocketConnection.getInstance()
                .subscribe(this.props.channel, (msg) => {
                    this.onMessage(msg);
                });
        }
    }

    /**
     * Zignorujemy informację o zmianie tego eventa,
     * bo został zmieniony w aktualnym kalendarzu
     * @private
     */
    private eventChangedInCalendar: string[] = [];

    eventChanged(arg: { id: string; date: string; allDay: boolean; start: string; end: string }) {
        console.log("EEEEEEEEE", arg);
        this.eventChangedInCalendar.push(arg.id);
        this.parentFragment.call("editTask", arg);
    }

    eventClick(e: EventClickArg) {
        let action = e.event.extendedProps.openWireAction;
        if(action){

            let id = parseInt(e.event.id);

            if(id){
                this.parentFragment.action(action, {
                    id: parseInt(e.event.id)
                });
            }else{
                this.parentFragment.action(action, {
                    rec: (e.event.id)
                });
            }



        }
    }

    onRemove() {
        super.onRemove();
        if(this.subHandle){
            DceWebSocketConnection.getInstance().unsubscribe(this.subHandle);
        }
    }

    fetchEvents(arg: { start: Date; end: Date; startStr: string; endStr: string; timeZone: string }, successCallback: (events: EventInput[]) => void) {

        console.log("FETCH EVENTS ---   " , arg);

        this.parentFragment.call("getEvents", {
            from: arg.startStr,
            to: arg.endStr
        }).then(resp => {

            if(resp.hasData('events')){
                successCallback(
                    resp.getData('events') as EventInput[]
                )
            }

        });

    }

    private callWebSocket(method: string, param: string){

        if(method === 'resolved'){
            let msg = JSON.parse(param) as WebSocketMsgResolved;
            console.log("CALENDAR MSG", msg);

            let eventApi = this.calendar.getEventById(msg.id);
            if(eventApi){
                eventApi.classNames.push('fc-type-done');
                eventApi.setProp('editable', false);
            }
        }

        if(method == 'changed'){
            let obj = JSON.parse(param) as EventInput;

            //element zmiony w akrualnym kalendarzu, pomijamy zmiany
            var index = this.eventChangedInCalendar.indexOf(obj.id);
            if (index !== -1) {
                this.eventChangedInCalendar.splice(index, 1);


                console.log('CHANGE DISCARDER', this.eventChangedInCalendar);
                return;
            }

            let eventApi = this.calendar.getEventById(obj.id);
            if(eventApi){
                eventApi.remove();
                this.calendar.addEvent(obj);
            }
        }


        if(method == 'created'){
            let obj = JSON.parse(param) as EventInput;
            this.calendar.addEvent(obj);
        }

    }

    private onMessage(msg: DceWebSocketIncomingMessage) {
        let x = msg.message.indexOf(">");

        let method = msg.message.substr(1, x-1);
        let msgstr = msg.message.substr(x+1);

        console.log("WEBSOCKET METHOD: ", method, msgstr);

        this.callWebSocket(method, msgstr);
    }

}